// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__VN8d2","container":"styles_container__lot-k","title":"styles_title__XTJcq","wrapper":"styles_wrapper__1O36I","answer":"styles_answer__30-Yr"};